import React, { Component } from 'react';
import { Button, Checkbox } from 'antd';
import { WARNING } from '../../config/media';

class ConfirmNewWallet extends Component {
	state = {
		isConfirm: false
	};

	handleChangeCheckbox = () => {
		this.setState({
			isConfirm: !this.state.isConfirm
		});
	};

	render() {
		const { isConfirm } = this.state;
		const { onSubmit, data } = this.props;
		const List1 = data.map((item, index) => {
			if (index < 6) {
				return (
					<div>
						{index + 1}. <b>{item}</b>
					</div>
				);
			}
			return null;
		});
		const List2 = data.map((item, index) => {
			if (index > 5) {
				return (
					<div>
						{index + 1}. <b>{item}</b>
					</div>
				);
			}
			return null;
		});
		return (
			<div className="holla-wallet-confirm">
				<div className="holla-wallet-confirm-desc">
					Make a back up of your seed recovery phrase. Write or memorize
					these words and in the precise order. Store the phrase some-
					where safe! Your phrase can be used to recover your wallet.
				</div>
				<div className="holla-wallet-confirm-recover-phrase">
					<span className="title">Recovery Phrase</span>
					<div>{List1}</div>
					<div>{List2}</div>
				</div>
				<div className="holla-wallet-confirm-warning">
					<img src={WARNING} alt="warning" />
					<div className="holla-wallet-confirm-warning-text">
						<b>WARNING:</b> Never disclose your phrase. Never type it on a
						website.
						<br /> This phrase will no longer be available once you leave
						this page.
					</div>
				</div>
				<div className="holla-wallet-confirm-check">
					<Checkbox value={isConfirm} onChange={this.handleChangeCheckbox}>
						Yes, I confirm that I’ve made a back up of my seed recovery
						phrase.
					</Checkbox>
				</div>

				<Button
					block
					type="primary"
					onClick={onSubmit}
					disabled={!isConfirm}
				>
					Create Wallet
				</Button>
			</div>
		);
	}
}

export default ConfirmNewWallet;
